<template>
  <div class="timeline cricket-match-timeline">
    <cricket-coverage 
      :showVsTeam="false"
      @coverageSelected="onCoverageSelected()"></cricket-coverage>
    <loading-state :state="state"></loading-state>
    <div v-if="matches">
      <div v-if="timeline.length">
        <div>
          <relative-match
            v-for="relMatch in timeline"
            :key="relMatch.key"
            :relativeMatch="relMatch">
          </relative-match>
        </div>
      </div>
      <div v-else-if="currentPage === 0">
        No matches found for this team
      </div>
      <div v-else>
        No more matches
      </div>
      <div v-if="matches.next_page" ref="nextPageLoader" class="nextpage-loading">
        <loading-state :state="timelineState"></loading-state>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '@/utils'
import { Enum } from '@/helpers/enum'
import { DataState, AppState } from '@/state'

import  RelativeMatch  from '@/components/cricket/RelativeMatch'

import { CricketTeamPerformance } from '@/models/cricket/performance'
import { CricketTeam } from '@/models/cricket/team'
import { CricketCoverage } from '@/models/cricket/core'


export default {
  components : {
    'RelativeMatch': RelativeMatch,
  },
  data () {
    return {
      teamKey: this.$route.params.key,
      currentPage: 1,
      loadingPage: null,
      matches: null,
      timeline: [],
      state: DataState.newLoading(),
      timelineState: DataState.newLoading(),

      observer: null,
      intersected: false,
    }
  },
  watch: {
    '$route' (to, from) {
      const fromPageKey = this.createPageKey(from.params, from.query)
      const toPageKey = this.createPageKey(to.params, to.query)
      if (fromPageKey !== toPageKey) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    createPageKey (params, query) {
      let key = [params.key, params.board, params.competition]
      if (params.year) {
        key.push(params.year)
      }

      if (query.vsTeam) {
        key.push(query.vsTeam)
      }

      let page = 1
      if (query.page) {
        page = query.page
      }

      key.push(page.toString())

      return key.join(',')
    },

    attachObserver () {
      this.observer = new IntersectionObserver(entries => {
        if (this.intersected) { return }
        const firstEntry = entries[0]
        if (firstEntry.isIntersecting) {
          // this.intersected = true
          // this.observer.disconnect()
          this.onNextPageVisible()
        }
      })

      this.$nextTick(() => {
        if (this.observer) {
          this.observer.observe(this.$refs.nextPageLoader)
        }
      })
    },
    onNextPageVisible () {
      // console.log('Matches visible')
      if (this.matches && this.matches.next_page) {
        let nextPage = this.matches.next_page
        if (nextPage == this.loadingPage) {
          console.log('ignoring next page')
          return
        }

        if (nextPage > this.currentPage) {
          this.loadNextPageMatches(true)
        }
      }
    },

    onViewOpenned () {
      const selected = CricketCoverage.State.selected

      this.teamKey = this.$route.params.key
      selected.board = this.$route.params.board
      selected.competition = this.$route.params.competition
      selected.year = this.$route.params.year
      selected.vsTeam = this.$route.query.vsTeam
      this.currentPage = this.$route.query.page

      AppState.updateActivePage(`cricket_team_${this.teamKey}_timeline`)
      this.loadNextPageMatches()
    },

    loadNextPageMatches (useTimelineLoading) {
      let page = this.currentPage
      if (this.matches && this.matches.next_page) {
        page = this.matches.next_page
      }

      let state = this.state
      if (useTimelineLoading) {
        state = this.timelineState
      }

      state.changeToLoading()

      const selectedCoverage = CricketCoverage.State.selected
      const selectedTeam = CricketTeam.State.selected
      this.loadingPage = page

      console.log('Loading timeline of page', page)
      CricketTeamPerformance.fetchTimeline(page, selectedTeam, selectedCoverage).then(matches => {
        this.currentPage = page || 1
        this.loadingPage = null
        this.matches = matches
        this.timeline.push(...matches.matches)
        state.changeToLoaded()
        this.onDataReady()
      }).catch((error) => {
        console.error(error)
        state.changeToError(error)
      })

    },

    prepareToReopen () {
      this.teamKey = null
      this.matches = null
      this.timeline = []
      this.intersected = false
      this.currentPage = 1
      this.loadingPage = null
      this.timelineState = DataState.newLoading()

      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    },

    refreshView () {

    },

    onDataReady () {
      if(!this.observer) {
        this.attachObserver()
      }
    },

    onCoverageSelected () {
      const selected = CricketCoverage.State.selected
      this.$router.push(selected.buildUrl('cricketTeamTimeline', this.teamKey))
    }
  }
}
</script>
